import { render } from "./protocalInfo2.vue?vue&type=template&id=23849d4f&scoped=true"
import script from "./protocalInfo2.vue?vue&type=script&lang=js"
export * from "./protocalInfo2.vue?vue&type=script&lang=js"

import "./protocalInfo2.vue?vue&type=style&index=0&id=23849d4f&lang=scss&scoped=true"

import exportComponent from "D:\\XGprogect\\海尔会员\\haierhuiyuan-phone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23849d4f"]])

export default __exports__